import "survey-core/defaultV2.min.css";
import { Model } from "survey-core";
import { Survey } from "survey-react-ui";
import { useLocation } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import dayjs from "dayjs";
import { axiosInstance } from "../../utils/networking";
export const SurveyContent = (props: any) => {
  const [originalSurveyData, setOriginalSurveyData] = useState<any>({});
  const [availableEvents, setAvailableEvents] = useState<any>([]);
  useEffect(() => {
    axiosInstance.get(`/events/past?period=2w`).then((res) => {
      setAvailableEvents(res.data.events);
    });
    if (props.survey_id) {
      axiosInstance
        .get(`/survey/result?survey_result_id=${props.survey_id}`)
        .then(async (res) => {
          if (res.status === 200) {
            // console.log(res.data.survey_result);
            setOriginalSurveyData(res.data.survey_result);
          } else {
            console.log("API Error at getting survey result");
          }
        });
    }
  }, [props.survey_id]);
  const eventsList = availableEvents.map((event: any) => {
    return `${dayjs(event.start.local).format("MM-DD-YYYY")} - ${
      event.name.text
    }`;
  });

  const surveyJson = {
    elements: [
      {
        type: "panel",
        name: "contact-information",
        elements: [
          {
            type: "text",
            name: "first-name",
            title: "First name",
            isRequired: true,
          },
          {
            type: "text",
            name: "last-name",
            title: "Last name",
            isRequired: true,
          },
          {
            type: "text",
            name: "email",
            title: "Email Address",
            isRequired: true,
          },
        ],
      },
      {
        name: "q1",
        title: "What event did you attend?",
        type: "dropdown",
        choices: eventsList,
        isRequired: true,
      },
      {
        name: "q2",
        title:
          "How likely are you to recommend this event to a friend or colleague?",
        type: "rating",
        rateCount: 10,
        rateMax: 10,
        description:
          "Use a scale of 1-10 where 1 indicates you are not at all likely to recommend, and 10 means you are extremely likely to recommend.",
      },
      {
        name: "q3",
        title: "Overall how satisfied are you with the event?",
        type: "rating",
        rateCount: 10,
        rateMax: 10,
        description:
          "Use a scale of 1-10 where 1 indicates you are very unsatisfied, and 10 means you are very satisfied.",
      },
      {
        name: "q4",
        title: "How likely are you to join Oakland Thrive for another event?",
        type: "rating",
        rateCount: 10,
        rateMax: 10,
        description:
          "Use a scale of 1-10 where 1 indicates you are not at all likely to rejoin, and 10 means you are extremely likely to rejoin.",
      },
      {
        name: "q5",
        title: "Quality of venue?",
        type: "rating",
        rateCount: 10,
        rateMax: 10,
        description:
          "Use a scale of 1-10 where 1 indicates you are very unsatisfied, and 10 means you are very satisfied.",
      },
      {
        name: "q6",
        title:
          "What other training topics would you like to see offered by Oakland Thrive?",
        type: "comment",
        rows: 3,
        autoGrow: true,
        allowResize: false,
      },
      {
        name: "q7",
        title: "Any other comments or suggestions?",
        type: "comment",
        rows: 3,
        autoGrow: true,
        allowResize: false,
      },
      {
        name: "q10",
        title:
          "Would you like Oakland Thrive to contact you as a follow up to this event?",
        type: "radiogroup",
        choices: ["Yes", "No"],
      },
      {
        name: "q8",
        title: "How did you hear about this event/Oakland Thrive?",
        type: "radiogroup",
        choices: [
          "Social Media",
          "Eventbrite",
          "Small Business Consultant",
          "Word of Mouth",
        ],
        showOtherItem: true,
        otherPlaceholder: "Please specify...",
        otherText: "Other",
      },
      {
        name: "q9",
        title:
          "Can we use your comments, name and company name on Oakland Thrive promotional materials in the future?",
        type: "radiogroup",
        choices: ["Yes", "No"],
      },
    ],
  };

  const survey = new Model(surveyJson);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const caseId = queryParams.get("caseId");
  const referralID = queryParams.get("referralId");
  survey.onComplete.add((sender, options) => {
    axiosInstance
      .post(`/survey/event_survey_result`, {
        activity_type: "Event Survey",
        surveyResult: {
          survey_result: sender.data,
          case_id: caseId,
          survey_id: "65412693f9ecc07bf529219f",
          referral_id: referralID,
          activity_date: dayjs().format("YYYY-MM-DD"),
        },
      })
      .then((res) => {
        if (res.status === 200) {
        } else {
          console.log("API Error");
        }
      });
  });

  survey.data = originalSurveyData;
  return (
    <Box sx={{ textAlign: "left" }}>
      <Survey model={survey} />
    </Box>
  );
};

const PublicEventSurvey = () => {
  return (
    <>
      <Box sx={{ maxWidth: "600px", margin: "auto" }}>
        <Typography variant="h4" sx={{ textAlign: "center" }}>
          Oakland Thrive Post-Event Survey
        </Typography>
        <br></br>
        <Typography sx={{ textAlign: "left" }}>
          Thank you for attending our Oakland Thrive training! Please take a
          moment to provide feedback on your experience at our training event.
          You're feedback will help make us better! Thank you!
        </Typography>
        <br></br>
        <Typography sx={{ textAlign: "left" }}>
          If you captured any pictures from today's event and you'd be willing
          to share, please send pictures to events@oaklandthrive.org and be sure
          to tag us on social media @OaklandThrive
        </Typography>
      </Box>

      <SurveyContent></SurveyContent>
    </>
  );
};
export default PublicEventSurvey;
